var map = {
	"./adult/nn/3 01 Tulleord Intro.mp3": 618,
	"./adult/no/3 01 Tulleord Intro.mp3": 619,
	"./youth/de/3 01 Tulleord Intro.mp3": 620,
	"./youth/nn/3 01 Tulleord Intro.mp3": 621,
	"./youth/no/3 01 Tulleord Intro.mp3": 622,
	"./youth/se/3 01 Tulleord Intro.mp3": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 617;